import React from "react";
import "../../main-component/CaptainTCCards/CaptainTCCards.css";
import coinImg from "../../images/captain-tc/coin.png";
import {
  FaWallet,
  FaCoins,
  FaInfoCircle,
  FaGift,
  FaGlobe
} from "react-icons/fa";

const RewardBenefitsContent = () => {
  return (
    <div className="captain-tc-content" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      
      {/* 1st Promo Webcontent */}
      <div className="captain-tc-promo-webcontent" style={{ marginBottom: "30px" }}>
        <h2 style={{ color: "#d4af37", margin: "0 0 5px", letterSpacing: "2px", fontWeight: "bold" }}>CAPTAIN TC</h2>
        <h3 style={{ margin: "0 0 5px", fontSize: "1.5rem", letterSpacing: "1px" }}>REWARDS PROGRESS</h3>
        <h4 style={{ color: "#d4af37", margin: "0 0 20px", fontWeight: "normal", fontSize: "1rem" }}>TOPCOIN UK</h4>
        
        <div style={{ background: "rgba(212, 175, 55, 0.1)", padding: "10px", borderRadius: "5px", marginBottom: "25px" }}>
          <h4 style={{ margin: 0, color: "#d4af37", fontSize: "1.1rem" }}>REWARD EVERY 250 REWARD TOPCOIN</h4>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
          {/* Row 1 */}
          <div className="captain-tc-promo-row">
            <div className="captain-tc-promo-item">250<br/>REWARD TOPCOIN</div>
            <div className="captain-tc-promo-arrow">→</div>
            <div className="captain-tc-promo-item" style={{ color: "#d4af37" }}><FaGift size={20} style={{marginBottom: "5px"}} /><br/>REWARD PAYMENT</div>
            <div className="captain-tc-promo-arrow">→</div>
            <div className="captain-tc-promo-item">500<br/>REWARD TOPCOIN</div>
          </div>

          {/* Row 2 */}
          <div className="captain-tc-promo-row">
            <div className="captain-tc-promo-item">750<br/>REWARD TOPCOIN</div>
            <div className="captain-tc-promo-arrow">→</div>
            <div className="captain-tc-promo-item" style={{ color: "#d4af37" }}><FaGift size={20} style={{marginBottom: "5px"}} /><br/>REWARD PAYMENT</div>
            <div className="captain-tc-promo-arrow">→</div>
            <div className="captain-tc-promo-item">1,000<br/>REWARD TOPCOIN</div>
          </div>

          <div style={{ margin: "5px 0", fontStyle: "italic", color: "#ccc", fontSize: "0.9rem" }}>
            CONTINUE EVERY 250 REWARD TOPCOIN
          </div>

          {/* Row 3 */}
          <div className="captain-tc-promo-row">
            <div className="captain-tc-promo-item">4,750<br/>REWARD TOPCOIN</div>
            <div className="captain-tc-promo-arrow">→</div>
            <div className="captain-tc-promo-item" style={{ color: "#d4af37" }}><FaGift size={20} style={{marginBottom: "5px"}} /><br/>REWARD PAYMENT</div>
            <div className="captain-tc-promo-arrow">→</div>
            <div className="captain-tc-promo-item">5,000<br/>REWARD TOPCOIN</div>
          </div>
        </div>

        <div style={{ marginTop: "30px", padding: "15px", borderTop: "1px solid rgba(212, 175, 55, 0.3)", borderBottom: "1px solid rgba(212, 175, 55, 0.3)" }}>
          <h4 style={{ margin: "0 0 5px", fontSize: "1.1rem" }}>FOR 20 TIMES TILL YOU REACH</h4>
          <h3 style={{ margin: 0, color: "#d4af37", fontSize: "1.4rem" }}>★ 5,000 REWARD TOPCOIN ★</h3>
        </div>

      </div>

      {/* 2nd Promo Webcontent */}
      <div className="captain-tc-promo-webcontent-3" style={{ marginBottom: "30px" }}>
        <h2 style={{ color: "#d4af37", margin: "0 0 5px", letterSpacing: "2px", fontWeight: "bold" }}>CAPTAIN TC</h2>
        <h3 style={{ margin: "0 0 5px", fontSize: "1.5rem", letterSpacing: "1px" }}>REWARDS CARD</h3>
        <h4 style={{ color: "#d4af37", margin: "0 0 25px", fontWeight: "normal", fontSize: "1.1rem" }}>★ TOPCOIN UK ★</h4>

        <div className="captain-tc-promo3-box">
          <h3 style={{ margin: "0 0 10px", fontSize: "1.3rem", fontWeight: "normal" }}>COMPLETE YOUR CARD</h3>
          <h2 style={{ margin: "0 0 5px", color: "#d4af37", fontSize: "1.8rem" }}>★ ★ ★ 5,000 ★ ★ ★</h2>
          <h3 style={{ margin: "0 0 15px", fontSize: "1.2rem", fontWeight: "normal" }}>REWARD TOPCOIN</h3>
          <p style={{ margin: 0, color: "#ccc", fontSize: "0.9rem" }}>
            UNLOCK THE FULL REWARD VALUE OF YOUR CAPTAIN TC REWARDS CARD
          </p>
        </div>

        
        
      </div>
        
      {/* 3rd Promo Webcontent */}
      <div className="captain-tc-promo-webcontent-4" style={{ marginBottom: "30px" }}>
        <div style={{ color: "#d4af37", marginBottom: "15px", fontSize: "1.5rem" }}><FaInfoCircle /></div>
        <h2 style={{ margin: "0 0 5px", fontSize: "1.3rem", letterSpacing: "1px", fontWeight: "bold" }}>FOR MORE INFORMATION</h2>
        <h3 style={{ margin: "0 0 10px", color: "#d4af37", fontSize: "1.6rem" }}>DISCOVER CAPTAIN TC REWARDS</h3>
        <p style={{ margin: "0 0 30px", fontSize: "0.95rem", color: "#ccc" }}>VIEW CARD BENEFITS, REWARD VALUES &amp; HOW IT WORKS</p>

        

        <h2 style={{ margin: "0 0 10px", fontSize: "1.5rem", letterSpacing: "1px" }}>UNLOCK MORE WITH CAPTAIN TC</h2>


        <a href="https://www.topcoinuk.com" className="captain-tc-promo4-btn" target="_blank" rel="noopener noreferrer">
          <FaGlobe /> WWW.TOPCOINUK.COM <span>➔</span>
        </a>

        <div className="captain-tc-promo4-grid">
          <div className="captain-tc-promo4-item">
            <div style={{ color: "#d4af37", fontSize: "1.5rem" }}><FaGift /></div>
            <div>REWARD<br/>BENEFITS</div>
          </div>
          <div className="captain-tc-promo4-item">
            <div style={{ color: "#d4af37", fontSize: "1.5rem" }}><FaCoins /></div>
            <div>CARD<br/>INFORMATION</div>
          </div>
          <div className="captain-tc-promo4-item">
            <div style={{ color: "#d4af37", fontSize: "1.5rem" }}><FaInfoCircle /></div>
            <div>HOW IT<br/>WORKS</div>
          </div>
          <div className="captain-tc-promo4-item">
            <div style={{ color: "#d4af37", fontSize: "1.5rem" }}><FaWallet /></div>
            <div>JOIN OUR<br/>COMMUNITY</div>
          </div>
        </div>

        <div style={{ marginTop: "20px", paddingTop: "20px", borderTop: "1px solid rgba(212, 175, 55, 0.3)", color: "#d4af37", fontWeight: "bold", letterSpacing: "1px" }}>
          TOGETHER FOR A BRIGHTER TOMORROW
        </div>
      </div>

      {/* 4th Promo Webcontent */}
      <div className="captain-tc-promo-webcontent-5" style={{ marginBottom: "30px" }}>
        <h1 style={{ margin: "0 0 5px", fontSize: "2rem", letterSpacing: "1px", fontWeight: "bold" }}>TopCoin UK®</h1>
        <h3 style={{ color: "#d4af37", margin: "0 0 30px", fontSize: "1.3rem", fontWeight: "normal", letterSpacing: "2px" }}>A BRIGHTER TOMORROW</h3>


        <h2 style={{ margin: "0 0 10px", fontSize: "1.6rem" }}>Exclusively for TopCoin UK Customers</h2>
    
        <div className="captain-tc-promo5-content">
          <p className="captain-tc-promo5-text">
            <strong style={{ color: "#fff" }}>Captain TC Rewards Cards</strong> are available exclusively to <strong style={{ color: "#d4af37" }}>TopCoin UK customers.</strong>
          </p>
          <p className="captain-tc-promo5-text">
            If you are already a <strong>TCUK member</strong>, simply become a <strong>TopCoin UK customer</strong> by making a qualifying purchase from a participating company on the platform.
          </p>
          <p className="captain-tc-promo5-text">
            Once your qualifying purchase is completed, you can access the Captain TC Rewards Card programme and start earning eligible rewards.
          </p>

          <ul className="captain-tc-promo5-list">
            <li>SIGN IN TO YOUR ACCOUNT</li>
            <li>MAKE A QUALIFYING PURCHASE</li>
          </ul>
          
          <div style={{ textAlign: "center" }}>
            <a href="https://www.topcoinuk.com" className="captain-tc-promo5-btn" target="_blank" rel="noopener noreferrer">
              MAKE A QUALIFYING PURCHASE <span>&gt;</span>
            </a>
          </div>
        </div>
      </div>

    </div>
  );
};

export default RewardBenefitsContent;
